import AddPeIntegration from './AddPeIntegration';

export default AddPeIntegration;
